// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Material catalog (/user/materials) and its offer-editor tools. Scoped to the page root class
   and to .materials-tools (offer editor, catalog picker). */

.materials-page {
  padding-block-end: 24px;
}

.materials-page--loading {
  display: flex;
  justify-content: center;
  padding-block: 48px;
}

.materials-page .mat-full,
.materials-tools .mat-full {
  width: 100%;
}

.materials-page .mat-muted,
.materials-tools .mat-muted {
  color: var(--ds-text-secondary, rgba(0, 0, 0, 0.55));
  font-size: 12px;
}

.materials-page .mat-number,
.materials-tools .mat-number {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.materials-page .mat-wrap,
.materials-tools .mat-wrap {
  overflow-wrap: anywhere;
}

.materials-page .mat-section {
  margin-block-start: 16px;
}

.materials-page .mat-row-editor {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  padding-block: 8px;
  border-block-end: 1px solid var(--ds-border, #f0f0f0);
}

@media (min-width: 768px) {
  .materials-page .mat-row-editor {
    grid-template-columns: 2fr 3fr 2fr 2fr auto;
    align-items: center;
  }
}

.materials-page .mat-explain {
  margin-block-end: 16px;
}

.materials-page .mat-basket--highlight {
  border-color: var(--ds-brand, #157f9f);
  box-shadow: 0 0 0 2px var(--ds-brand-100, rgba(21, 127, 159, 0.15));
}

/* Offer editor and catalog picker */
.materials-tools {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.materials-tools--block {
  display: block;
}

.materials-tools .mat-pick-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  padding-block: 10px;
  border-block-end: 1px solid var(--ds-border, #f0f0f0);
}

.materials-tools .mat-pick-row__text {
  flex: 1 1 220px;
  min-width: 0;
}

.materials-tools .mat-pick-row__qty {
  display: flex;
  gap: 8px;
  align-items: center;
}

.materials-tools .mat-margin {
  margin-block: 12px;
}

.materials-tools .mat-calc-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/materials/materials.css"],"names":[],"mappings":"AAAA;4DAC4D;;AAE5D;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,oDAAoD;EACpD,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE;IACE,2CAA2C;IAC3C,mBAAmB;EACrB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,mEAAmE;AACrE;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* Material catalog (/user/materials) and its offer-editor tools. Scoped to the page root class\n   and to .materials-tools (offer editor, catalog picker). */\n\n.materials-page {\n  padding-block-end: 24px;\n}\n\n.materials-page--loading {\n  display: flex;\n  justify-content: center;\n  padding-block: 48px;\n}\n\n.materials-page .mat-full,\n.materials-tools .mat-full {\n  width: 100%;\n}\n\n.materials-page .mat-muted,\n.materials-tools .mat-muted {\n  color: var(--ds-text-secondary, rgba(0, 0, 0, 0.55));\n  font-size: 12px;\n}\n\n.materials-page .mat-number,\n.materials-tools .mat-number {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.materials-page .mat-wrap,\n.materials-tools .mat-wrap {\n  overflow-wrap: anywhere;\n}\n\n.materials-page .mat-section {\n  margin-block-start: 16px;\n}\n\n.materials-page .mat-row-editor {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n  padding-block: 8px;\n  border-block-end: 1px solid var(--ds-border, #f0f0f0);\n}\n\n@media (min-width: 768px) {\n  .materials-page .mat-row-editor {\n    grid-template-columns: 2fr 3fr 2fr 2fr auto;\n    align-items: center;\n  }\n}\n\n.materials-page .mat-explain {\n  margin-block-end: 16px;\n}\n\n.materials-page .mat-basket--highlight {\n  border-color: var(--ds-brand, #157f9f);\n  box-shadow: 0 0 0 2px var(--ds-brand-100, rgba(21, 127, 159, 0.15));\n}\n\n/* Offer editor and catalog picker */\n.materials-tools {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.materials-tools--block {\n  display: block;\n}\n\n.materials-tools .mat-pick-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: space-between;\n  padding-block: 10px;\n  border-block-end: 1px solid var(--ds-border, #f0f0f0);\n}\n\n.materials-tools .mat-pick-row__text {\n  flex: 1 1 220px;\n  min-width: 0;\n}\n\n.materials-tools .mat-pick-row__qty {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.materials-tools .mat-margin {\n  margin-block: 12px;\n}\n\n.materials-tools .mat-calc-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px 12px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
